import { AvgBasketSizeInsight, InsightGenericData, MonetaryInsight } from '../types';

type AvgBasketSizeTotal = AvgBasketSizeInsight;

export enum CustomerType {
  NEW = 'FIRST_TIME',
  RETURNING = 'RETURNING',
}

export type BasketSizeData<L1, L2 = never> = {
  label: L1 | null;
  total: AvgBasketSizeTotal;
  split?: BasketSizeData<L2>[] | null;
};

export type BasketSizeInsight = InsightGenericData &
  MonetaryInsight & {
    data: {
      basketSize: null | BasketSizeData<null, CustomerType>;
    };
  };
